import { extendServiceContainer } from '@iotize/tap';
import { MqttService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    mqtt: MqttService;
  }
}

export const _TAP_SERVICE_EXTENSION_MQTT_ = extendServiceContainer(
  'mqtt',
  MqttService,
);
